import { IFormActualsTargetsSettings } from 'legacy/lut/classes/models/partner360/IFormActualsTargetsSettings'

import { IJBPPlanningItem } from '../../models/IJBPPlanning'

interface IUpdateL3CollapsedItemsProps {
  items: IJBPPlanningItem[]
  formats: IFormActualsTargetsSettings[]
  settingsIndex: number
  newValue: boolean
  fy: number
  partnerId: string
  isIgnorePartnerId: boolean
}

interface IUpdateL3CollapsedItemsResult {
  isUpdated: boolean
  updatedItems: IJBPPlanningItem[]
}

export const updateL3CollapsedItems = ({
  items,
  formats,
  settingsIndex,
  newValue,
  fy,
  partnerId,
  isIgnorePartnerId,
}: IUpdateL3CollapsedItemsProps): IUpdateL3CollapsedItemsResult => {
  if (settingsIndex < formats.length) {
    const setting = formats[settingsIndex]

    // Items filtered on Top level by: PartnerId, IsActuals, IsTarget, IsQuota
    const sourceData = items.filter(
      (item) =>
        (item.PartnerId === partnerId || isIgnorePartnerId) &&
        item.ProgramTypes === setting.ProgramType &&
        item.Category === setting.Category &&
        item.SubCategory === setting.SubCategory &&
        item.L3Category === setting.L3Category &&
        item.FYear === fy
      //el.FQuarter === fq // All quarters
    )

    if (sourceData.length >= 1) {
      const updatedItems = [...items]

      sourceData.forEach((currentItem) => {
        const newItem = {
          ...currentItem,
          IsCollapsed: newValue ? 1 : 0,
          IsNoPlan: newValue ? currentItem.IsNoPlan : 0,
          // IsCollapsed not changing SoB
          IsChanged: 1,
        }
        const index = items.indexOf(currentItem)
        updatedItems.splice(index, 1, newItem)
      })

      return { isUpdated: true, updatedItems }
    } else {
      // error in data
    }
  }

  return { isUpdated: false, updatedItems: items }
}
